import { Contact } from "./contact.model";
import { DropDownItem, SimpleResponse } from "./genericResponse.model";
import { Lead } from "./lead.model";
import { keyValue } from "./search.model";

export interface CalenderResponse extends SimpleResponse {
    mailingData: MailingData[];
    apptData: ApptData[];
    phoneData: PhoneData[];
    taskData: TaskData[];
    taskByTeamOffice: TaskData[];
    dropDownItem: DropDownItem[];
    cnt: number;
    taskCount: PhoneData[];
    contactList: Contact[];
    leadList: Lead[];
}

export interface CalenderResponseDayView {
    apptData: ApptData[];
    taskDataByTeamOffice: TaskData[];
    callListCount: number;
}

export interface MailingData {
    mailingId: number;
    clpUserId: number;
    clpCompanyId: number;
    mailingTypeCode: number;
    fromType: number;
    toType: number;
    mailingStartTime: Date;
    subject: string;
    salutation: number;
    body: string;
    documentList: string;
    emailTemplateId: number;
    mailMergeTemplateId: number;
    signature: string;
    category: number;
    customSearchId: number;
    status: number;
    dtCompleted: Date;
    ccore: number;
    campaignEventId: number;
    runId: number;
    clpServiceRunId: number;
    dtCreated: Date;
    lastName: string;
    firstName: string;
}
export interface PhoneData {
    year: number;
    month: number;
    day: number;
    count: number;

}
export interface ApptData {
    apptID: number;
    clpUserID: number;
    clpCompanyID: number;
    category: number;
    generalTypeCode: number;
    contactTypeCode: number;
    leadTypeCode: number;
    proposalTypeCode: number;
    projectTypeCode: number;
    typeId: number;
    apptStartTime: Date;
    apptEndTime: Date;
    isAllDay: boolean;
    isPhoneCall: boolean;
    isPrivate: boolean;
    subject: string;
    location: string;
    notes: string;
    leadId: number;
    contactId: number;
    projectId: number;
    proposalId: number;
    reminderClp: boolean;
    reminderEmail: boolean;
    reminderTime: Date;
    reminderEmails: string;
    reminderSent: boolean;
    reminderNote: string;
    reminderEmailTemplateId: number;
    showNoteInUserReminder: boolean;
    inApptTemplateId: number;
    documentList: string;
    rApptId: number;
    check1: boolean;
    check2: boolean;
    check3: boolean;
    class1: number;
    status: number;
    campaignId: number;
    campaignEventId: number;
    runId: number;
    dtCreated: Date;
    isTxtMsgReminder: boolean;
    isTxtMsgUserReminder: boolean;
    reminderTxtMsgTemplateId: number;
    userLastFirst: string;
    codeDisplay: string;
    ownerName: string;
    contactName: string;
    companyName: string;
    companyId: number;
    companyType: string;
    contactIsShareable: number;
    contactObj: Contact;
    leadObj: Lead;
    colorCode: string;
}

export interface TaskData {
    taskId: number;
    clpUserID: number;
    clpCompanyID: number;
    ownerId: number;
    campaignId: number;
    campaignEventId: number;
    runId: number;
    firstName: string;
    lastName: string;
    taskDesc: string;
    category: number;
    priority: number;
    status: number;
    dtDue: Date;
    reminderTime: Date;
    dtCreated: Date;
    hours: number;
    cost: number;
    isPrivate: boolean;
    reminderClp: boolean;
    reminderEmail: boolean;
    reminderSent: boolean;
    taskSummary: TaskSummary[];
    contactIsShareable: number;
    contactObj?: Contact;
    leadObj?: Lead;

}
export interface LeadStatus {
    leadStatusCode: number;
    clpCompanyId: number;
    display: string;
    sorder: number;
}
export interface ApptLeadType {
    apptLeadTypeCode: number;
    clpCompanyId: number;
    display: string;
    colorCode: number;
    sorder: number;
}
export interface ApptContactType {
    apptContactTypeCode: number;
    clpCompanyId: number;
    display: string;
    colorCode: string;
    sorder: number;
}
export interface ApptGeneralType {
    apptGeneralTypeCode: number;
    clpCompanyId: number;
    display: string;
    colorCode: string;
    sorder: number;
}
export interface ApptSummary {
    FullName: string;
    ApptSubject: string;
    ApptStatus: string;
    ApptCategory: string;
    LeadId: number;
    LeadDesc: string;
    Display: string;
    ColorCode: string;
    ApptLocation: string;
    ApptNotes: string;
    CallLink: string;
    Time: string;
    Day: string;
    LeadStatusDisplay: string;
    PhoneCallDisplay: string;
    contactFullName: string;
}

export interface TaskSummary {
    FullName: string;
    LeadId: number;
    LeadDesc: string;
    CallLink: string;
    Day: string;
    LeadStatusDisplay: string;
    companyName: string;
    add1: string;
    add2: string;
    add3: string;
    city: string;
    state: string;
    Phone: string;
    Mobile: string;
    HomePhone: string;
    AltPhone: string;
    Fax: string;
    Email: string;
}

export interface CalenderFiltersResponse extends SimpleResponse {
    filterUsers: keyValue[];
    filterTeam: keyValue[];
    filterOffice: keyValue[];
}
export interface WeekViewDisplay {
    dispDate: Date;
    taskData: TaskData[];
    apptData: ApptData[];
    phoneData: PhoneData[];
}


export interface SchedulerCal {
    id?: any;
    dataItem?: any;
    start: Date;
    startTimezone?: string;
    end: Date;
    endTimezone?: string;
    isAllDay?: boolean;
    title: string;
    description?: string;
    recurrenceRule?: string;
    recurrenceId?: any;
    recurrenceExceptions?: Date[];
    count: number;
}

export interface UpdateTaskMonthView {
    strOldDate: string;
    StrNewDate: string;
    clpuserID: number;
    status: number;
}

export interface MonthDDResponse {
    monthList: DropDownItem[];
}

export interface CreateScheduleRequest {
    Name: string;
    Email: string;
    Mobile: string;
    PCalID: number;
    DateSelected: string;
    OverrideClass5Code: number;
    Notes: string;
    ApptID: number;
    ContactID: number;
    AppliesToCLPUserID: number;
    LiveConnectCLPUserID: number;
    strLiveConnectCLPUserName: string;
    isApptCreated: boolean;
}

export interface CreateScheduleResponse extends SimpleResponse {
    PCalMessage: string;
    eMessageType: number;
    isApptCreated: boolean;
}


export interface CalenderSchedulerResponse extends SimpleResponse {
    FullName: string;
    PCalMessage: string;
    Email: string;
    Mobile: string;
    Notes: string;
    Title: string;
    CompanyName: string;
    RepName: string;
    ImageUrl: string;
    TimeZone: number;
    RedirectUrl: string;
    pcl: PCal;
    eMessageType: number;
    ApptId: number;
    contactId: number;
    ProspectCLPUserID: number;
    AppliesToCLPUserID: number;
    OverrideClass5Code: number;
    StandardName: string;
}

export interface PCal {
    pCalID: number;
    pCalKey: string;
    cLPCompanyID: number;
    cLPUserID: number;
    title: string;
    message: string;
    workDaySpan: string;
    weekDaysBusy: string;
    dailySlots: string;
    specificSlots: string;
    typesToIgnore: string;
    webFormID: number;
    cTCampaignTemplateID: number;
    cTCLPUserID: number;
    logoURL: string;
    bGColor: string;
    companyName: string;
    repName: string;
    thankYouMessage: string;
    dtCreated: string;
    appliesToCLPUserID: number;
    calName: string;
    apptLength: number;
    ignorePhoneCalls: boolean;
    leadTime: number;
    calendarsCLPUserIDs: string;
    typesGeneralToIgnore: string;
    timeInterval: number;
    isSendImmediateReminder: boolean;
    isSendUserAlertEmail: boolean;
    userFullName: string;
}

export interface TimeSlotsRequest {
    pCalKey: string;
    strSelectedDate: string;
    appliesToCLPUserID: number;
}

export interface TimeSlotsResponse extends SimpleResponse {
    timeSlots: DropDownItem[];
}

export interface CalenderDynamicRequest {
    pkey: string;
    aid: number;
    cid: number;
    cpu: number;
    cl5: number;
    uid: string;
    nm: string;
    ph: string;
    em: string;
    cmt: string;
}
